import * as React from 'react';
import UnsafeFAQ from './FAQ';
import UnsafeHero from './Hero';
import UnsafeHowItWorks from './HowItWorks';
import UnsafeOurProjects from './OurProjects';
import UnsafePress from './Press';
import UnsafeReviews from './Reviews';
import UnsafePriceTiers from './PriceTiers';
import UnsafeWhatYouGet from './WhatYouGet';
import UnsafeProjectSlider from './ProjectSlider';
import UnsafeOfflineStudio from './OfflineStudio';
import ErrorBoundary from '@ids/components/ErrorBoundary/ErrorBoundary';

const withErrorBoundary = (boundaryName: string, Component: React.ElementType) => {
    const AugmentedComponent = (props: React.ComponentPropsWithoutRef<typeof Component>) => (
        <ErrorBoundary boundaryName={boundaryName}>
            <Component {...props} />
        </ErrorBoundary>
    );
    AugmentedComponent.displayName = boundaryName;
    return AugmentedComponent;
};

export const FAQ = withErrorBoundary('faq-block', UnsafeFAQ);
export const Hero = withErrorBoundary('hero-block', UnsafeHero);
export const HowItWorks = withErrorBoundary('how-it-works-block', UnsafeHowItWorks);
export const OurProjects = withErrorBoundary('our-projects-block', UnsafeOurProjects);
export const Press = withErrorBoundary('press-block', UnsafePress);
export const Reviews = withErrorBoundary('reviews-block', UnsafeReviews);
export const PriceTiers = withErrorBoundary('price-tiers-block', UnsafePriceTiers);
export const WhatYouGet = withErrorBoundary('what-you-get-block', UnsafeWhatYouGet);
export const ProjectSlider = withErrorBoundary('project-slider-block', UnsafeProjectSlider);
export const OfflineStudio = withErrorBoundary('offline-studio-block', UnsafeOfflineStudio);
